import type { ApiClient } from "../../../infrastructure/http/apiClient";
import type {
  Customer,
  CustomerAppointmentHistory,
  CustomerHistoryWindow,
  CustomerNote,
  ListCustomerAppointmentHistoryInput,
  ListCustomerNotesInput,
  ListCustomersInput,
  PaginatedCustomerResponse
} from "../domain/customer";

const defaultPage = 1;
const defaultCustomerPageSize = 20;
const defaultDetailPageSize = 20;

export function loadCustomers(
  apiClient: ApiClient,
  input: ListCustomersInput = {}
): Promise<PaginatedCustomerResponse<Customer>> {
  const params = new URLSearchParams({
    page: String(input.page ?? defaultPage),
    page_size: String(input.pageSize ?? defaultCustomerPageSize)
  });

  return apiClient.get<PaginatedCustomerResponse<Customer>>(`/api/v1/customers?${params.toString()}`);
}

export function loadCustomerDetail(apiClient: ApiClient, customerID: string): Promise<Customer> {
  return apiClient.get<Customer>(`/api/v1/customers/${encodeURIComponent(customerID)}`);
}

export function loadCustomerNotes(
  apiClient: ApiClient,
  customerID: string,
  input: ListCustomerNotesInput = {}
): Promise<PaginatedCustomerResponse<CustomerNote>> {
  const params = new URLSearchParams({
    page: String(input.page ?? defaultPage),
    page_size: String(input.pageSize ?? defaultDetailPageSize)
  });

  return apiClient.get<PaginatedCustomerResponse<CustomerNote>>(`/api/v1/customers/${encodeURIComponent(customerID)}/notes?${params.toString()}`);
}

export function loadCustomerAppointmentHistory(
  apiClient: ApiClient,
  customerID: string,
  input: ListCustomerAppointmentHistoryInput
): Promise<PaginatedCustomerResponse<CustomerAppointmentHistory>> {
  const params = new URLSearchParams({
    start: input.start.toISOString(),
    end: input.end.toISOString(),
    page: String(input.page ?? defaultPage),
    page_size: String(input.pageSize ?? defaultDetailPageSize)
  });

  return apiClient.get<PaginatedCustomerResponse<CustomerAppointmentHistory>>(`/api/v1/customers/${encodeURIComponent(customerID)}/appointments?${params.toString()}`);
}

export function buildCustomerHistoryWindow(now = new Date()): CustomerHistoryWindow {
  const start = new Date(now);
  start.setUTCDate(start.getUTCDate() - 276);

  const end = new Date(now);
  end.setUTCDate(end.getUTCDate() + 90);

  return { start, end };
}
